import 'react-phone-number-input/style.css';
import React, {Dispatch, SetStateAction} from 'react';
import Input from 'react-phone-number-input/input';
import {SelectContainer} from './styles';
import {InputField} from './styles';
import {theme} from '../../../styles/darkTheme';
import {useTranslation} from '../../../context/language';
import CustomCountryFlag from '../../atoms/CustomCountryFlag';

interface CustomPhoneInputProps {
  value: any;
  setValue: Dispatch<SetStateAction<any>>;
  disabled?: boolean;
}

const CustomPhoneInput: React.FC<CustomPhoneInputProps> = ({
  value,
  setValue,
  disabled = false,
}) => {
  const {text} = useTranslation();
  return (
    <SelectContainer>
      <CustomCountryFlag theme={theme} />
      <Input
        country="US"
        placeholder={text.enterPhoneNumber}
        inputComponent={InputField}
        value={value}
        onChange={setValue}
        disabled={disabled}
      />
    </SelectContainer>
  );
};

export default CustomPhoneInput;
